exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-header[data-v-28632182]{height:45px;line-height:45px;font-size:16px;border-bottom:1px solid #d9e0e6}.body-item[data-v-28632182]{overflow:hidden;position:relative;margin-top:1px;width:100%}.body-title[data-v-28632182]{background:#e87b92;padding:8px;position:absolute;color:#fff;margin-left:15px;margin-top:-15px}.body-content[data-v-28632182]{line-height:30px;font-size:15px;min-height:70px;border:1px solid #ddd;border-radius:5px;margin-top:30px;padding-top:27px;padding-left:15px;padding-bottom:19px}.product-buyer-name[data-v-28632182]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-28632182","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/dialysisPre/index.vue
// module id = I01x
// module chunks = 0